/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalCommonStorageUploadMetadata interface.
 */
export function instanceOfInternalCommonStorageUploadMetadata(value) {
    if (!('filename' in value) || value['filename'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('size' in value) || value['size'] === undefined)
        return false;
    return true;
}
export function InternalCommonStorageUploadMetadataFromJSON(json) {
    return InternalCommonStorageUploadMetadataFromJSONTyped(json, false);
}
export function InternalCommonStorageUploadMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'filename': json['filename'],
        'url': json['url'],
        'mimeType': json['mime_type'],
        'size': json['size'],
    };
}
export function InternalCommonStorageUploadMetadataToJSON(json) {
    return InternalCommonStorageUploadMetadataToJSONTyped(json, false);
}
export function InternalCommonStorageUploadMetadataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'filename': value['filename'],
        'mime_type': value['mimeType'],
        'size': value['size'],
    };
}
